import React from "react"

function TimelineMarker(props) {
  return (
    <div className={`timeline-marker ${props.className}`}>{props.children}</div>
  )
}

export default TimelineMarker
